export default __webpack_public_path__ + "47b6a8201d4d84e66e3e058433d3e07b.png";